import { render } from "./LoadingDialog.vue?vue&type=template&id=53fab478&scoped=true"
import script from "./LoadingDialog.vue?vue&type=script&lang=js"
export * from "./LoadingDialog.vue?vue&type=script&lang=js"

import "./LoadingDialog.vue?vue&type=style&index=0&id=53fab478&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53fab478"]])

export default __exports__